"use strict";
const angular = require("angular");

import _ from "underscore";

export class DuplicateComponent {
  /*@ngInject*/
  constructor(LanguageService) {
    var that = this;
    this.ls = LanguageService;
    this.$onInit = function () {
      that.demand = that.resolve.demand;
      that.products = that.resolve.products;
    };
    this.cancel = function () {
      this.dismiss();
    };
  }

  parseValue(value, type) {
    if (value) {
      if (type === "date") {
        return new Date(value);
      }
      if (type === "integer") {
        return Number(value);
      }
      if (type === "decimal") {
        return Number(value);
      }
    }
    return value;
  }

  copy(form) {
    this.submitted = true;
    if (this.selectedProduct && this.demand && this.products && form.$valid) {
      //Extraire la source
      let product = _.findWhere(this.products, {
        id: this.demand.productId,
      });
      let srcListedModels = product.listedModels;
      let _inputsUses = [];
      for (var i in this.demand.input) {
        let inputModelId = this.demand.input[i].inputModelId;
        let imodel = srcListedModels[`input_${inputModelId}`];
        if ([50, 51].indexOf(imodel.sigedavMatchType) !== -1) {
          _inputsUses.push({
            value: this.parseValue(
              this.demand.input[i][imodel.type],
              imodel.type
            ),
            sigedavMatchType: imodel.sigedavMatchType,
            useNumber: this.demand.input[i].useNumber,
          });
        }
      }

      _inputsUses = _.sortBy(_inputsUses, "useNumber");
      _inputsUses = _.groupBy(_inputsUses, "useNumber");

      //Génerer une nouvelle demande vide avec le model séléctionner
      let inputs = {
        generals: [],
        uses: [[]],
      };
      for (var iname in this.selectedProduct.listedModels) {
        let elt = {
          value: null,
          inputModelId: this.selectedProduct.listedModels[iname].id,
          sigedavMatchType:
            this.selectedProduct.listedModels[iname].sigedavMatchType,
          type: this.selectedProduct.listedModels[iname].type,
        };
        if (this.selectedProduct.listedModels[iname].isGeneral) {
          inputs.generals.push(elt);
        } else {
          inputs.uses[0].push(elt);
        }
      }

      //Copier les informations dans la nouvelle demande
      let use = inputs.uses[0];
      inputs.uses = [];
      for (let u in _inputsUses) {
        let cUse = JSON.parse(JSON.stringify(use));
        let authorInput = _.findWhere(_inputsUses[u], {
          sigedavMatchType: 50,
        });
        let titleInput = _.findWhere(_inputsUses[u], {
          sigedavMatchType: 51,
        });
        cUse = _.map(cUse, function (actuUse) {
          if (actuUse.sigedavMatchType === 50) {
            actuUse.value = authorInput ? authorInput.value : null;
          } else if (actuUse.sigedavMatchType === 51) {
            actuUse.value = titleInput ? titleInput.value : null;
          }
          return actuUse;
        });
        inputs.uses.push(cUse);
      }
      this.close({
        $value: {
          productId: this.selectedProduct.id,
          projectId: this.demand.projectId,
          generals: inputs.generals,
          uses: inputs.uses,
        },
      });
    }
  }
}

export default angular
  .module("dalApp.permission.duplicate", [])
  .component("duplicate", {
    template: require("./duplicate.html"),
    controller: DuplicateComponent,
    bindings: {
      resolve: "<",
      close: "&",
      dismiss: "&",
    },
  }).name;



// WEBPACK FOOTER //
// ./client/app/permission/duplicate/duplicate.component.js